import { Checkbox, Grid, Header, Label, Segment } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import type PerimetreIdee from '../../../../../constants/simulation/perimetreIdee';
import type IdeeImportable from '../../../../../interfaces/simulation/ideeImportable';
import { getCouleurCategorie } from '../../../../../utils/simulation/etiquette';
import ImportIdeeImputation from './ImportIdeeImputation';

// Le service n'est rappele qu'en saisie decentralisee, le statut jamais :
// toutes les idees proposees sont pretes. L'auteur peut etre inconnu
const getMetaIdee = (idee: IdeeImportable, saisieBudgetService: boolean) =>
	[
		`Idée ID-${idee.numero}`,
		...(saisieBudgetService ? [idee.libelleService || 'Sans service'] : []),
		...(idee.auteur ? [`créée par ${idee.auteur}`] : []),
	].join(' · ');

interface ImportIdeeItemProps {
	idee: IdeeImportable;
	onToggle: () => void;
	// Cran actif : seuls les segments d'imputation qu'il ne garantit pas sont
	// rappeles
	perimetre: PerimetreIdee;
	saisieBudgetService: boolean;
	selected: boolean;
}

const ImportIdeeItem = ({
	idee,
	onToggle,
	perimetre,
	saisieBudgetService,
	selected,
}: ImportIdeeItemProps) => (
	<Segment
		className={`importIdeeItem${selected ? ' importIdeeItemSelectionnee' : ''}`}
		data-testid={`importIdeeItemID-${idee.numero}`}
		onClick={onToggle}
	>
		<Grid verticalAlign="middle">
			<Grid.Column width={1}>
				{/* Toute la zone est cliquable : la case ne gere pas le clic
				elle-meme, sans quoi la selection serait inversee deux fois */}
				<Checkbox checked={selected} readOnly />
			</Grid.Column>
			<Grid.Column width={11}>
				<Header
					content={idee.libelle}
					size="tiny"
					subheader={getMetaIdee(idee, saisieBudgetService)}
				/>
				<ImportIdeeImputation
					imputation={idee.imputation}
					perimetre={perimetre}
				/>
			</Grid.Column>
			<Grid.Column textAlign="right" width={4}>
				{idee.categorie && (
					<Label
						className="importIdeeItemCategorie"
						color={getCouleurCategorie(idee.categorie)}
						content={idee.categorie}
						title={idee.categorie}
					/>
				)}
				<div>
					<strong>{formatMontant(idee.montant)}</strong>
				</div>
			</Grid.Column>
		</Grid>
	</Segment>
);

export default ImportIdeeItem;
